import { EVENTS } from '@archetype-themes/utils/events'

class GiftCardRecipientForm extends HTMLElement {
  constructor() {
    super()
    this.bodyElement = document.body;
    this.htmlElement = document.documentElement;
    this.headerElement = document.querySelector('.header-section');
    this.toolBarElement = document.querySelector('.toolbar-section');
    this.productRecommendationsElement = document.querySelector('.product-recommendations-placeholder');

    this.send_gift_trigger = document.querySelector('[data-send-gift-card]');

    this.checkboxInput = this.querySelector('.switch-box input')
    this.checkboxInputLabel = this.checkboxInput.closest('.recipient-form-checkbox').querySelector('.recipient-checkbox-label')
    this.emailInput = this.querySelector('.recipient-form__email')
    this.nameInput = this.querySelector('.recipient-form__name')
    this.messageInput = this.querySelector('.recipient-form__message')
    this.dateInput = this.querySelector('.recipient-form__date')
    this.sendonInput = this.querySelector(`.gift-card-date-picker`);
    this.addEventListener('change', () => this.onChange())
    this.recipientFields = this.querySelector('.recipient-fields')

    this.checkboxInput.addEventListener('change', this.onChange.bind(this));

    this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
    this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
    this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
    this.defaultErrorHeader = this.errorMessage?.innerText;
    this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
    if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

    this.send_gift_trigger.addEventListener('click', this.clickOnSendButton.bind(this));
    this.closeBtn = this.querySelector('#close-popup');
    this.closeBtn.addEventListener('click', () => {
      this.clearPopupClasses();
      this.classList.add('hide');
      // this.checkboxInput.checked = false;
    });
  }

  
  connectedCallback() {
    this.abortController = new AbortController()

    document.addEventListener(EVENTS.ajaxProductError, (event) => {
      const productVariantID = event.target.querySelector('[name="id"]').value
      if (productVariantID === this.dataset.productVariantId) {
        this.displayErrorMessage(event.detail.errorMessage)
      }
    }, { signal: this.abortController.signal })

    document.addEventListener(EVENTS.ajaxProductAdded, (event) => {
      const productVariantID = event.target.querySelector('[name="id"]').value
      if (productVariantID === this.dataset.productVariantId) {
        this.clearInputFields()
        this.clearErrorMessage()
        this.hidePopup()
        this.clearPopupClasses()
      }
    }, { signal: this.abortController.signal })
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  onChange() {
    if (this.checkboxInput.checked) {
      this.nameInput.closest('.recipient-fields__field').classList.remove('hide');
      this.emailInput.closest('.recipient-fields__field').classList.remove('hide');
      this.sendonInput.closest('.recipient-fields__field').classList.remove('hide');
      this.messageInput.closest('.recipient-fields__field').classList.remove('hide');
      this.checkboxInputLabel.innerText = `The gift card you are buying will be emailed directly to the recipient.`;
      this.clearErrorMessage();
      this.addPopupClasses();
      /* this.enableInputFields();
      this.recipientFieldsLayout.classList.remove('hide');
      this.recipientFieldsLayout.classList.add('recipient-form-active');
      this.addPopupClasses(); */
      // this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
    } else {
      this.nameInput.closest('.recipient-fields__field').classList.add('hide');
      this.emailInput.closest('.recipient-fields__field').classList.add('hide');
      this.sendonInput.closest('.recipient-fields__field').classList.add('hide');
      this.messageInput.closest('.recipient-fields__field').classList.add('hide');
      this.checkboxInputLabel.innerText = `The gift card you are buying will be emailed to you.`;
      this.clearInputFields();
      this.clearErrorMessage();
      this.addPopupClasses();
     /*  this.clearPopupClasses();
      this.clearInputFields();
      this.disableInputFields();
      this.clearErrorMessage();
      this.recipientFieldsLayout.classList.add('hide')
      this.recipientFieldsLayout.classList.remove('recipient-form-active'); */
      // this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
    }
  }

  clearInputFields() {
    for (const element of this.querySelectorAll('.field__input')) {
      element.value = ''
    }
  }

  displayErrorMessage(body) {
    this.clearErrorMessage();
    this.errorMessageWrapper.classList.remove('hide');
    if (typeof body === 'object') {
      this.errorMessage.innerText = this.defaultErrorHeader;
      return Object.entries(body).forEach(([key, value]) => {
        const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
        const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
        const message = `${value.join(', ')}`;
        const errorMessageElement = this.querySelector(`#${errorMessageId}`);
        const errorTextElement = errorMessageElement?.querySelector('.error-message');
        if (!errorTextElement) return;

        if (this.errorMessageList) {
          this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
        }
        errorTextElement.innerText = `${message}.`;
        errorMessageElement.classList.remove('hide');
        const inputElement = this[`${key}Input`];
        if (!inputElement) return;

        inputElement.setAttribute('aria-invalid', true); 
        inputElement.setAttribute('aria-describedby', errorMessageId);
      });
    }

    this.errorMessage.innerText = body;
  }

  clearErrorMessage() {
    
    /* for (const inputElement of this.querySelectorAll('.field__input')) {
      inputElement.setAttribute('aria-invalid', false)
      inputElement.removeAttribute('aria-describedby')
      inputElement.classList.remove('field__input--error')
    } */
    if (this.errorMessageList) {
      this.errorMessageWrapper.classList.add("hide")
      this.errorMessageList.innerHTML = '';
    }
    this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
      field.classList.add('hide');
      const textField = field.querySelector('.error-message');
      if (textField) textField.innerText = '';
    });

    [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
      inputElement.setAttribute('aria-invalid', false);
      inputElement.removeAttribute('aria-describedby');
    });
  }

  clickOnSendButton(){
    this.classList.remove('hide');
    this.classList.add('recipient-form-active');
    this.addPopupClasses();
  }

  hidePopup(){
    this.classList.add('hide');
    this.classList.remove('recipient-form-active');
  }

  clearPopupClasses() {
    this.bodyElement.style.overflow = "auto";
    this.htmlElement.style.overflow = "auto";
    this.headerElement.classList.remove('z-0');
    this.toolBarElement.classList.remove('z-0');
    
    if ( this.productRecommendationsElement) {
      this.productRecommendationsElement.closest('.shopify-section').classList.remove('z-1');
    }
   
  }

  addPopupClasses() {
    this.bodyElement.style.overflow = "hidden";
    this.htmlElement.style.overflow = "hidden";
    this.headerElement.classList.add('z-0');
    this.toolBarElement.classList.add('z-0');
    if (this.productRecommendationsElement) {
      this.productRecommendationsElement.closest('.shopify-section').classList.add('z-1');
    }
  }

  createErrorListItem(target, message) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('href', target);
    a.innerText = message;
    li.appendChild(a);
    li.className = 'error-message';
    return li;
  }

}

customElements.define('gift-card-recipient-form', GiftCardRecipientForm)